<template>
  <a-locale-provider :locale="locale">
    <div id="app" :class="{'full-screen': spinning }">
    <!-- <Spin size='large' :spinning="spinning"> -->
      <Spin :spinning="spinning" size="large" tip="Loading...">
        <!-- <img class='loading-img' src='https://hzwimspic-1251601690.image.myqcloud.com/8a8a4570-797a-11ea-960a-dfcaf9876fd4_size_560x540#gif' slot="indicator" /> -->
        <router-view />
      </Spin>
    </div>
  </a-locale-provider>
</template>
<script>
  import { Spin } from 'ant-design-vue'
  import { LocaleProvider } from 'ant-design-vue'
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
  // import { tracker } from '@/utils/utils'
  import { SUPPORTBUZZTYPE, BUZZTYPE_LEYOU } from '@/utils/constants'
  import { isLeYou } from '@/utils/utils'
  import { report } from '@/utils/reportError'

  export default {
    components: {
      [LocaleProvider.name]: LocaleProvider,
      Spin
    },
    async beforeCreate() {
      if(isLeYou) {
        document.title = '商家平台'
      }
      const buzzTypeNumber = (this.$cookie.get('buzzType') || '') * 1
      const buzzType = isLeYou ? BUZZTYPE_LEYOU[buzzTypeNumber] : this.$BUZZTYPE[buzzTypeNumber]
      if (!SUPPORTBUZZTYPE.includes(buzzTypeNumber)) {
        report({
          msg: `此用户可能白屏, buzzType：${this.$cookie.get('buzzType')},${buzzTypeNumber}.`
        })
        return
      }
      // console.log('beforeCreate')
      this.$store.dispatch('getCMSConfig', { buzzType })
      if (process.env.VUE_APP_SEVERENV === 'BETA') {
        // 孩子王测试环境仍走老菜单
        isLeYou ? this.$store.dispatch('getMenusV2') : this.$store.dispatch('getMenus')
      } else {
        // 除育儿外都走新菜单
        if (buzzTypeNumber === 5 || buzzTypeNumber === 6) {
          this.$store.dispatch('getMenus')
        } else {
          this.$store.dispatch('getMenusV2')
        }
      }
      if (!isLeYou) {
        // 初始化获取统一待办数据
        this.$store.dispatch('queryUnifiedTaskSummary')
      }
    },
    data() {
      return {
        locale: zhCN,
      };
    },
    computed: {
      spinning() {
        return this.$store.state.spinning
      }
    }
  }
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;


  &.full-screen{
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .loading-img{
      width: 280px;
      height:270px;
    }
  }

}
.ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.25) !important;
}
body {
  min-width: 1366px!important;
  background: #f7f7f7;
}
</style>
